<template>
  <div class="md-layout">
    <md-toolbar
      id="departure_profile_header"
      md-elevation="0"
      class="md-transparent"
    >
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <div>
            <div class="md-headline">
              {{ departure.start_date | formatDate }}
            </div>
            <div class="md-body-1">
              <span>
                <md-icon v-if="tour.type.value == 'tour'" class="md-primary"
                  >public</md-icon
                >
                <md-icon v-else class="text-warning">event</md-icon>
                <router-link
                  :to="{
                    name: 'Adventure Profile',
                    params: { tourId: tour_id }
                  }"
                >
                  {{ tour.title }}</router-link
                >
              </span>
              <span v-if="departure.status"
                ><md-icon>
                  <i
                    v-if="departure.status.key == 'Confirmed'"
                    class="far fa-calendar-check text-success hi-price-icon"
                    ><md-tooltip md-direction="top"
                      >This Departure is Confirmed</md-tooltip
                    ></i
                  >
                  <i
                    v-else
                    class="far fa-calendar-times text-danger hi-price-icon"
                    ><md-tooltip md-direction="top"
                      >This Departure is
                      <strong>NOT</strong> Confirmed</md-tooltip
                    ></i
                  >
                </md-icon>
                {{ departure.status.description }}
              </span>
              <span>
                <md-icon class="md-primary">group</md-icon>
                {{ departure.num_passengers }} / {{ departure.max_group_size }}
              </span>

              <span v-if="currentRouteName != 'Departure Manifest'">
                <md-icon class="md-primary">list_alt</md-icon>
                <router-link :to="{ name: 'Departure Manifest' }">
                  Manifest</router-link
                >
              </span>
              <span v-else>
                <md-icon class="md-primary">list_alt</md-icon>
                <router-link :to="{ name: 'Departure Profile' }">
                  Departure</router-link
                >
              </span>

              <template v-if="tour.type.value == 'event'">
                <md-button
                  class="md-raised md-dense md-success"
                  @click.prevent="downloadAdventureData"
                >
                  <md-icon>file_download</md-icon>
                  Download Event Data
                </md-button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </md-toolbar>

    <router-view @departureUpdated="departureUpdated" />
  </div>
</template>

<script>
import tourApi from "@/services/api/tour";
import departureApi from "@/services/api/departure";

export default {
  props: ["tour_id", "departure_id"],

  data() {
    return {
      tour: {
        type: {
          value: "tour"
        }
      }
    };
  },

  components: {},

  methods: {
    getDeparture(departure_id, tour_id) {
      tourApi.getTour(tour_id).then(response => {
        this.tour = response.data;
        this.$store.dispatch("departures/fetchDeparture", {
          tourId: tour_id,
          departureId: departure_id
        });
      });
    },

    departureUpdated(departure) {
      this.departure = departure;
    },

    downloadAdventureData(buttonClicked) {
      departureApi
        .downloadAdventureBookings(this.departure.id)
        .then(response => {
          let downloadDoc = window.URL.createObjectURL(new Blob([response]));
          let docUrl = document.createElement("a");

          let tour = this.departure.tour.title.toLowerCase().replace(" ", "_");
          let filename = `bookings-${this.departure.start_date}-${tour}.csv`;

          docUrl.href = downloadDoc;
          docUrl.setAttribute("download", filename);
          document.body.appendChild(docUrl);
          docUrl.click();
        });
    }
  },

  watch: {
    "$route.params.departure_id": function(departureId) {
      this.getDeparture(this.departure_id, this.tour_id);
    }
  },

  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    departure() {
      return this.$store.state.departures.departure;
    }
  },

  created() {
    this.getDeparture(this.departure_id, this.tour_id);
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("departures/resetDeparture");
    next();
  }
};
</script>
<style lang="scss" scoped>
#departure_profile_header {
  margin-bottom: 1rem;

  .md-body-1 {
    display: flex;
    align-items: center;
  }

  .md-headline {
    margin-bottom: 0.5rem;
  }

  span {
    display: inline-block;
    margin-right: 1rem;
  }
}
</style>
